import Model from '@/models/Model';
import api from '@/services/Api';

export default class Invoice extends Model {
    get route () {
        return 'invoicing/invoices';
    }

    static get className () {
        return 'Invoice';
    }

    restoreInvoiceToConcept () {
        return api.put(`invoicing/restore/${this.id}`);
    }

    static downloadCSV (ids) {
        return api.post('invoicing/download-csv', {
            ids,
        });
    }
}
